<template>
  <header class="page-header">
    <div v-on:click="toJustis()" class="logo">
      <div class="wrapper">
        <img class="ro-logo" src="../assets/logo-jenv-justis.svg" alt data-fallback="../assets/logo-fallback.png">
      </div>
    </div>
    <div class="wrapper">
      <nav v-if="!showMenuButton" class="primary-page-nav">
        <slot name="primary-nav"></slot>
      </nav>
      <nav v-else class="primary-page-nav">
        <a v-on:click="toggleMenu" id="menu-button">Menu</a>
      </nav>
      <div v-if="menuOpen" class="collapsed-menu">
        <slot name="primary-nav"></slot>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    name: 'dji-header',
    data(){ return {
      menuOpen: false
    }},
    methods: {
      toggleMenu(event) {
        this.menuOpen = !this.menuOpen;
      },
      toJustis(){
        window.location.href = 'https://www.justis.nl';
      }
    },
    computed: {
      showMenuButton() {
        return window.innerWidth <= 928;
      }
    }
  }
</script>

<style lang="scss">
  @import "../_common.scss";

  .page-header {
    display: inline-block;
    position: relative;
	  border-bottom: 1px solid #e6e6e6;
  }

  .logo {
    display: inline-block;
    width: 100%;
    cursor: pointer;
  }

  .wrapper {
    max-width: 980px;
    margin: 0px auto;
    background-color: white;

    .ro-logo {
      padding: 0px 0px 10px 50%;
      margin-left: -22px;
    }
  }

  .primary-page-nav {
    max-width: 980px;
    height: 44px;
    line-height: 40px;
    background: white;
    display: flex;
    font-size: 20px;

    a {
      &:hover {
        text-decoration: underline;
      }
    }

    & > * { // These are probably buttons or anchor tags, but using * gives the user some freedom.
      color: black;

      padding: 0 1.25rem 0 1.25rem;
      display: block;
      text-decoration: none;

      &:hover {
        text-decoration: none;
        color: black;
        background-color: white;
      }
    }

    a#menu-button {
      padding: 4px 10px 4px 24px;
      height: 24px;
      background: white url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZjRiOTE0Ny04MTNhLTQyYmUtYmY4Yi1kNDEwZDRlNTNhOTEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RkQxOEM4NzkxNTYyMTFFNDgyOTI4MzMyQjVDM0ZERDgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RkQxOEM4NzgxNTYyMTFFNDgyOTI4MzMyQjVDM0ZERDgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0ZjRiOTE0Ny04MTNhLTQyYmUtYmY4Yi1kNDEwZDRlNTNhOTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGY0YjkxNDctODEzYS00MmJlLWJmOGItZDQxMGQ0ZTUzYTkxIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+NBmcTAAAACFJREFUeNpiZGBg+M9ABGBiIBIw/v9PlIEkmDgi3QgQYACUVAkHeBoXRQAAAABJRU5ErkJggg==") no-repeat 6px 7px;
      line-height: 18px;
      color: black;
      font-size: 0.875rem;
      text-align: center;

      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .link-active {
    font-weight: bold;
    color:black;
    background-color: white;
  }

  .collapsed-menu {
    background-color: white;

    a {
      display: block;
      margin: 0px 10px;
      padding: 6.4px 0px;
      border-top: 1px solid white;
      color: black;
      background-color: white;
    }
  }

  @media screen and (max-device-width: 928px) {
    .primary-page-nav {
      padding: 0px 10px;
      border-top: 10px solid white;
    }
  }

  @media screen and (max-device-width: 480px) {
    .ro-logo {
      content:url("../assets/logo-fallback.png");
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue